import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Button } from '@components/button/Button';
import { LoginSource } from '@pages/Login/constants';
import { RegistrationContactFooter } from '@pages/Login/SignUpView/RegistrationContactFooter';
import { RegistrationFormFooter } from '@pages/Login/SignUpView/RegistrationFormFooter';
import { signUpContainerSx } from '@pages/Login/SignUpView/SignUpView.styles';
import { TERMS_OF_USE_URL } from '@pages/Login/SignUpView/registrationContent';

export const BrokerTermsAcceptanceStep = ({
  title,
  recaptchaWidget,
  isCreateUserLoading,
  isGeneratingToken,
  loginSource,
  onCreateAccount,
  onBackToSignIn,
  onSelectDifferentRole,
}: {
  title: string;
  recaptchaWidget: React.ReactNode;
  isCreateUserLoading: boolean;
  isGeneratingToken: boolean;
  loginSource: LoginSource;
  onCreateAccount: () => void;
  onBackToSignIn: () => void;
  onSelectDifferentRole?: () => void;
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Grid container sx={[{ textAlign: 'center' }, signUpContainerSx]}>
      <Grid size={{ xs: 12 }}>
        <Typography variant='h5'>{title}</Typography>
      </Grid>

      <Grid size={{ xs: 12 }} sx={{ mt: 3, textAlign: 'left' }}>
        <Typography variant='bodySmall' sx={{ color: 'text.caption', lineHeight: 1.6 }}>
          By selecting &ldquo;Create Account,&rdquo; I acknowledge and agree to the{' '}
          <Box
            component='a'
            href={TERMS_OF_USE_URL}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ color: 'secondary.main' }}
          >
            Terms of Use
          </Box>{' '}
          and confirm that all information submitted is true and accurate. I affirm that I am duly authorized and
          appropriately licensed to solicit, negotiate, and/or write insurance business in all jurisdictions in which I
          conduct business. I further agree to immediately notify LIO Insurance of any suspension, expiration,
          termination, restriction, or other lapse in such license, appointment, or authorization.
        </Typography>
      </Grid>

      {recaptchaWidget && (
        <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
          {recaptchaWidget}
        </Grid>
      )}

      <Grid
        size={{ xs: 12, sm: 'auto' }}
        sx={{
          margin: 'auto',
          mt: 3,
        }}
      >
        <Button
          variant='contained'
          fullWidth
          isLoading={isCreateUserLoading || isGeneratingToken}
          onClick={onCreateAccount}
        >
          {isGeneratingToken ? 'Verifying...' : 'Create Account'}
        </Button>
      </Grid>

      <RegistrationFormFooter
        loginSource={loginSource}
        onBackToSignIn={onBackToSignIn}
        onSelectDifferentRole={onSelectDifferentRole}
      />
    </Grid>
    <RegistrationContactFooter />
  </Box>
);
